import { render, staticRenderFns } from "./accessibility.vue?vue&type=template&id=47af9687&scoped=true&lang=pug&"
import script from "./accessibility.vue?vue&type=script&lang=js&"
export * from "./accessibility.vue?vue&type=script&lang=js&"
import style0 from "./accessibility.vue?vue&type=style&index=0&id=47af9687&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47af9687",
  null
  
)

/* custom blocks */
import block0 from "~/lang/user?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230324173659%2Fcomponents%2Fsite%2Fnav%2Faccessibility.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports